import React, { Component } from 'react';
import SubscriptionSelection from './SubscriptionSelection';
import SubscriptionReceivers from './SubscriptionReceivers';
import DicountEntry from './DiscountEntry';
import Checkbox from 'material-ui/Checkbox';

import Paper from 'material-ui/Paper';

import LinearProgress from 'material-ui/LinearProgress';

import { Col, Row } from 'react-flexbox-grid';

import { Step, StepButton, Stepper } from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';

const style = {
    height: 100,
    width: 100,
    margin: 20,
    textAlign: 'center',
    display: 'inline-block',
};

class SubscriptionsNewView extends Component {
    constructor() {
        super();
        this.state = {
            accepted_agbs: false,
        };
    }

    componentDidMount = () => {
        console.log('mounting');
        this.props.clearSubscriptionData();
        this.props.fetchPlans();
    };

    subscriptionType = type => {
        if (type === 'yearly') {
            return '25 EUR / Monat (jährlich abgerechnet)';
        }
        if (type === 'monthly') {
            return '30 EUR / Monat (monatlich abgerechnet)';
        }
    };

    renderDuration = payment_period => {
        if (payment_period === 'yearly') {
            return '12 Monate';
        } else {
            return '1 Monat';
        }
    };

    duration = payment_period => {
        if (payment_period === 'yearly') {
            return 12;
        } else {
            return 1;
        }
    };

    totalPrice = (subscription, coupon) => {
        return subscription.get('amount') * (1 - this.props.coupon.get('discount'));
    };

    regularPrice = subscription => {
        return subscription.getIn(['amount'], 0);
    };

    handleSubmit = values => {
        const plain = values.toJS();
        this.props.updateSubscriptionConfiguration(plain);
    };

    handleReceiversSubmit = values => {
        this.props.saveReceivers(values.get('members'));
    };

    navigateToList = () => {
        this.props.clearSubscriptionData();
        this.props.push('/subscriptions/list');
    };

    renderError = text => {
        const style = {
            backgroundColor: '#ff979a',
            padding: '20px',
            textAlignment: 'center',
            margin: '20px',
        };

        return <div style={style}>{text}</div>;
    };

    renderPrice = (validMembers, coupon) => {
        if (coupon.get('discount')) {
            return (
                <div>
                    {validMembers.count()} * (
                    {this.regularPrice(this.props.subscriptionDetails, coupon)}-{' '}
                    {this.regularPrice(this.props.subscriptionDetails) * coupon.get('discount')} €
                    Coupon *{' '}
                    {this.renderDuration(this.props.subscriptionDetails.get('paymentPeriod'))}) ={' '}
                    <strong>
                        {validMembers.count() *
                            this.totalPrice(this.props.subscriptionDetails, coupon) *
                            this.duration(this.props.subscriptionDetails.get('paymentPeriod'))}
                        € (netto zzgl. MWST)
                    </strong>
                </div>
            );
        } else {
            return (
                <div>
                    {validMembers.count()} * {this.regularPrice(this.props.subscriptionDetails)} € *{' '}
                    {this.renderDuration(this.props.subscriptionDetails.get('paymentPeriod'))} ={' '}
                    <strong>
                        {validMembers.count() *
                            this.regularPrice(this.props.subscriptionDetails) *
                            this.duration(this.props.subscriptionDetails.get('paymentPeriod'))}
                        € (netto zzgl. MWST)
                    </strong>
                </div>
            );
        }
    };

    render() {
        const stepIndex = this.props.subscriptionDetails.get('step');
        const validMembers = this.props.subscriptionDetails
            .get('members')
            .filter(member => member.get('email') !== '' && member.get('email') !== null);

        let style = {
            opacity: 1,
        };
        if (this.props.isFetching === true) {
            style = {
                opacity: 0.25,
                pointerEvents: 'none',
            };
        }
        return (
            <div>
                {this.props.isFetching && (
                    <Row>
                        <Col md={12} sm={12} xs={12}>
                            <LinearProgress
                                mode="indeterminate"
                                color="#3babd0"
                                style={{
                                    left: '0px',
                                    height: '10px',
                                    top: '63px',
                                    right: '0px',
                                    position: 'absolute',
                                }}
                            />
                        </Col>
                    </Row>
                )}
                {this.props.showNoAccountWarning && (
                    <h2>Bitte vervollständigen Sie zunächst Ihre <a href="/account">Rechnungsadresse</a></h2>
                )}
                {!this.props.showNoAccountWarning && (
                    <div>
                        <h2>Neue Software-Abos erwerben</h2>

                        <div style={style}>
                            <Stepper
                                linear={false}
                                activeStep={stepIndex}
                                style={{ marginBottom: '30px' }}>
                                <Step>
                                    <StepButton
                                        onClick={() => this.props.changeSubscriptionStep(0)}>
                                        Wählen Sie ein Preismodel
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={() => this.props.changeSubscriptionStep(1)}>
                                        Wieviele Software-Abos benötigen Sie?
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={() => this.props.changeSubscriptionStep(2)}>
                                        Software-Abos kostenpflichtig bestellen
                                    </StepButton>
                                </Step>
                            </Stepper>
                            {stepIndex == 0 && (
                                <SubscriptionSelection
                                    plans={this.props.plans}
                                    coupons={this.props.coupons}
                                    isFetchingCoupon={this.props.isFetchingCoupon}
                                    handleCouponCode={this.props.handleCouponCode}
                                    initialValues={this.props.subscriptionDetails}
                                    selectSubscriptionTypeHandler={
                                        this.props.selectSubscriptionType
                                    }
                                />
                            )}
                            {stepIndex == 1 && (
                                <SubscriptionReceivers
                                    dispatch={this.props.dispatch}
                                    updateReceivers={this.props.updateReceivers}
                                    onSubmit={this.handleReceiversSubmit}
                                    initialValues={this.props.subscriptionDetails}
                                />
                            )}
                            {this.props.subscriptionDetails.get('selectedType') &&
                                validMembers.count() !== 0 && (
                                    <Paper
                                        zDepth={1}
                                        style={{
                                            padding: '30px',
                                            marginBottom: '30px',
                                            marginTop: '30px',
                                        }}>
                                        <h3 style={{}}>Software-Abos kostenplfichtig bestellen</h3>
                                        <div style={{ padding: '20px' }}>
                                            <dl>
                                                <dt>Preismodel:</dt>
                                                <dd>
                                                    {this.subscriptionType(
                                                        this.props.subscriptionDetails.get(
                                                            'selectedType'
                                                        )
                                                    )}
                                                </dd>
                                                <dt>Laufzeit:</dt>
                                                <dd>
                                                    {this.renderDuration(
                                                        this.props.subscriptionDetails.get(
                                                            'paymentPeriod'
                                                        )
                                                    )}
                                                </dd>
                                                <dt>Anzahl der Software-Abos:</dt>
                                                <dd>{validMembers.count()}</dd>
                                                <dt>Gesamtpreis</dt>
                                                <dd>
                                                    {this.renderPrice(
                                                        validMembers,
                                                        this.props.coupon
                                                    )}
                                                </dd>
                                            </dl>
                                            <DicountEntry
                                                planVariantId={this.props.subscriptionDetails.getIn(
                                                    ['planVariantId'],
                                                    ''
                                                )}
                                            />
                                        </div>
                                        <h4>Software-Abo-Empfänger:</h4>
                                        <ul style={{ marginBottom: '20px' }}>
                                            {validMembers.map(member => (
                                                <li>{member.get('email')}</li>
                                            ))}
                                        </ul>
                                        {stepIndex === 2 &&
                                            validMembers.count() !== 0 &&
                                            this.props.subscriptionDetails.get('selectedType') && (
                                                <div>
                                                    <a
                                                        href="https://start.bstools.de/?webapp=true#/module/10432803"
                                                        target="_blank">
                                                        Allgemeine Geschäftsbedingungen BSTools GmbH
                                                    </a>
                                                    <br />
                                                    <br />
                                                    <Checkbox
                                                        label="Hiermit bestätige ich die BSTools-ABGs und den Kauf des Software-Abo zum angezeigten Preis. Die Rechnung wird per Mail versandt und ist sofort zur Zahlung fällig."
                                                        checked={this.state.accepted_agbs}
                                                        onCheck={() => {
                                                            this.setState({
                                                                accepted_agbs: !this.state
                                                                    .accepted_agbs,
                                                            });
                                                        }}
                                                    />
                                                    <br />
                                                    <RaisedButton
                                                        primary={true}
                                                        label="Bestellung abschließen"
                                                        disabled={!this.state.accepted_agbs}
                                                        onClick={() =>
                                                            this.props.createSubscription({
                                                                code: this.props.coupon.get('code'),
                                                                planVariantId: this.props.subscriptionDetails.get(
                                                                    'planVariantId'
                                                                ),
                                                                subscription: this.props.subscriptionDetails
                                                                    .merge({
                                                                        host:
                                                                            window.location
                                                                                .protocol +
                                                                            '//' +
                                                                            window.location.host,
                                                                    })
                                                                    .toJS(),
                                                            })
                                                        }
                                                    />
                                                </div>
                                            )}
                                    </Paper>
                                )}

                            {stepIndex > 1 &&
                                this.props.subscriptionDetails.get('selectedType') &&
                                validMembers.count() === 0 &&
                                this.renderError(
                                    'Sie müssen mindestens einen Empfänger für ein Software-Abo angeben!'
                                )}

                            {stepIndex > 0 &&
                                !this.props.subscriptionDetails.get('selectedType') &&
                                this.renderError('Bitte wählen Sie ein Preismodel aus')}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default SubscriptionsNewView;
